// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import { OnnxruntimeWebAssemblyBackend } from './backend-wasm';
export const wasmBackend = new OnnxruntimeWebAssemblyBackend();
